import React, { useState } from "react";
import { Paper, Grid, TableRow, TableCell } from "@mui/material";
import lock from "../../assets/images/Lock.svg";
import "./EventCard.scss";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import inpalyImg from "../../assets/images/sports/inplay.svg";
import moment from "moment";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import { addExchangeBet } from "../../store";
import { BsData } from "../../models/BsData";
import Betslip from "../../components/BetSlip/BetSlip";

type TableProps = {
  events: any;
  bets: BsData[];
  addExchangeBet: (data) => void;
};

const EventCard: React.FC<TableProps> = (props) => {
  const { events, bets, addExchangeBet } = props;
  const [selectedRow, setSelectedRow] = useState<string>("");
  const { provider } = useParams();
  let operatorId = sessionStorage.getItem("psOperatorId");
  let navigate = useNavigate();

  return (
    <Grid container spacing={2} className="grid">
      {events && events.length ? (
        events.map((row) => (
          <Grid
            item
            md={4}
            xs={12}
            className="grid-item"
            onClick={(data) => {
              navigate(
                `/lobby/${provider}/${row.sportId}/${row.eventId}/${row.competitionId}`
              );
            }}
          >
            <Paper key={row.eventName} className="paper">
              <NavLink
                to={`/lobby/${provider}/${row.sportId}/${row.eventId}/${row.competitionId}`}
                className="navlink"
              >
                <div className="header">
                  <div className="event">
                    <div>{row?.eventName}</div>
                  </div>
                  <div className="date-col">
                    <span className="date">
                      {operatorId === "MPC1"
                        ? moment(row.openDate).format("DD-MM-YYYY hh:mm A")
                        : moment(row.openDate).format("MM-DD-YY hh:mm A")}
                    </span>
                    <span className="live-icon">
                      {row.status === "IN_PLAY" ? (
                        <img src={inpalyImg} alt="live" />
                      ) : null}
                    </span>
                  </div>
                </div>
              </NavLink>

              <div className="card-body">
                {row &&
                row.markets &&
                row.markets.matchOdds &&
                row.markets.matchOdds.length &&
                row.markets.matchOdds[0] &&
                row.markets.matchOdds[0].runners.length &&
                row.markets.matchOdds[0].marketId !== "" ? (
                  row.markets.matchOdds[0].runners.map((runner, idx) => {
                    return (
                      <>
                        <div className="odd-box" key={idx}>
                          <div className="runner"> {runner?.runnerName}</div>
                          <div className="odds-div">
                            <div className="exch-odd-view">
                              {runner?.backPrices.leangth === 0 ||
                              runner?.backPrices?.[0]?.price === 0 ||
                              !runner?.backPrices?.[0]?.price ? (
                                <div className="odd-button-content back">
                                  <div className="price">
                                    <img
                                      src={lock}
                                      className="lock-img"
                                      alt="lock-img"
                                    />
                                  </div>{" "}
                                </div>
                              ) : (
                                <div
                                  className="button-content back"
                                  // onClick={() => {
                                  //   if (row.status === "IN_PLAY")
                                  //     addExchangeBet({
                                  //       eventId: row.eventId,
                                  //       eventName: row.eventName,
                                  //       marketId: row?.marketId,
                                  //       marketName: "Match Odds",

                                  //       oddValue:
                                  //         runner?.backPrices?.[0]?.price,
                                  //       betType: "BACK",
                                  //       marketType: "MATCH_ODDS",
                                  //       stakeAmount: 0,
                                  //       runnerId: runner.runnerId,
                                  //       runnerName: runner.runnerName,
                                  //       competitionId: row.competitionId,
                                  //       sportId: row.sportId,
                                  //       minLimit: row.markets.matchOdds[0]
                                  //         ?.limits?.minBetValue
                                  //         ? row.markets.matchOdds[0]?.limits
                                  //             ?.minBetValue
                                  //         : 0,

                                  //       maxLimit: row.markets.matchOdds[0]
                                  //         ?.limits?.maxBetValue
                                  //         ? row.markets.matchOdds[0]?.limits
                                  //             ?.maxBetValue
                                  //         : 0,
                                  //     });
                                  //   setSelectedRow(
                                  //     row?.eventId +
                                  //       row?.marketId +
                                  //       runner.runnerId +
                                  //       "MO"
                                  //   );
                                  // }}
                                >
                                  <div className="price">
                                    {Number(
                                      runner?.backPrices?.[0]?.price
                                    ).toFixed(2)}
                                  </div>{" "}
                                  <div className="size">
                                    {Number(
                                      runner?.backPrices?.[0]?.size
                                    ).toFixed(2)}
                                  </div>
                                </div>
                              )}{" "}
                            </div>{" "}
                            <div className="exch-odd-view">
                              {runner?.layPrices.length === 0 ||
                              !runner?.layPrices?.[0].price ||
                              runner?.layPrices?.[0]?.price === 0 ? (
                                <div className="odd-button-content lay">
                                  <div className="price">
                                    <img
                                      src={lock}
                                      className="lock-img"
                                      alt="lock-img"
                                    />
                                  </div>{" "}
                                </div>
                              ) : (
                                <div
                                  className="button-content lay"
                                  // onClick={() => {
                                  //   if (row.status === "IN_PLAY")
                                  //     addExchangeBet({
                                  //       eventId: row.eventId,
                                  //       eventName: row.eventName,
                                  //       marketId: row?.marketId,
                                  //       marketName: "Match Odds",

                                  //       oddValue: runner?.layPrices?.[0]?.price,
                                  //       betType: "LAY",
                                  //       marketType: "MATCH_ODDS",
                                  //       stakeAmount: 0,
                                  //       runnerId: runner.runnerId,
                                  //       runnerName: runner.runnerName,
                                  //       competitionId: row.competitionId,
                                  //       sportId: row.sportId,
                                  //       minLimit: row.markets.matchOdds[0]
                                  //         ?.limits?.minBetValue
                                  //         ? row.markets.matchOdds[0]?.limits
                                  //             ?.minBetValue
                                  //         : 0,

                                  //       maxLimit: row.markets.matchOdds[0]
                                  //         ?.limits?.maxBetValue
                                  //         ? row.markets.matchOdds[0]?.limits
                                  //             ?.maxBetValue
                                  //         : 0,
                                  //     });
                                  //   setSelectedRow(
                                  //     row?.eventId +
                                  //       row?.marketId +
                                  //       runner.runnerId +
                                  //       "MO"
                                  //   );
                                  // }}
                                >
                                  <div className="price">
                                    {runner?.layPrices?.[0]
                                      ? Number(
                                          runner?.layPrices?.[0]?.price
                                        ).toFixed(2)
                                      : "-"}
                                  </div>{" "}
                                  <div className="size">
                                    {runner?.layPrices[0]
                                      ? Number(
                                          runner?.layPrices?.[0]?.size
                                        ).toFixed(2)
                                      : "0:0"}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {bets.length > 0 &&
                        selectedRow ==
                          bets[0].eventId +
                            row?.marketId +
                            runner.runnerId +
                            "MO" ? (
                          <div className="mob-view">
                            <Betslip page={"market"} />
                          </div>
                        ) : null}
                      </>
                    );
                  })
                ) : (
                  <div className="card-body">
                    <div className="odd-box">No Runner</div>
                  </div>
                )}
              </div>
            </Paper>
          </Grid>
        ))
      ) : (
        <>
          <h5 className="message-empty-message">!!!No Events.!!!</h5>
        </>
      )}
    </Grid>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.betslip.bets,
    eventInfo: state.sportsBook.eventInfo,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventCard);
